module.exports = __webpack_public_path__ + "img/thumbnail-230571947.e47b6be6.jpeg";